import PropTypes from 'prop-types';
import { useState } from 'react';
// components
// hooks
import useAuth from '../hooks/useAuth';

import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

RoleGuard.propTypes = {
  children: PropTypes.node
};

export default function RoleGuard({ children }) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(!user);

  if (loading) return <LoadingScreen />;

  return <>{children}</>;
}
